import { CircularProgress } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useAuth } from "@poseidon/ui/components/AuthContext";
import DataGrid from "@poseidon/ui/components/DataGrid";
import { DataGridContainer } from "@poseidon/ui/components/DataGridContainer";
import { getColumnDefinition } from "./getColumnDefinition";
import { useApplicationsSummary } from "./useApplicationsSummary";

export default function ListApplications() {
  const { setError } = useErrorMessage();
  const { user } = useAuth();
  const { applications, loading, error } = useApplicationsSummary(user.uid);

  if (error) {
    setError(error);
  }
  if (loading || !applications) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }
  return (
    <DataGridContainer>
      <DataGrid
        columns={getColumnDefinition()}
        rows={applications}
        doubleClickSlug="applications"
        initialState={{
          sorting: {
            sortModel: [{ field: "applicationNumber", sort: "desc" }],
          },
        }}
      />
    </DataGridContainer>
  );
}
